

































import {Component, Vue, Watch} from "vue-property-decorator";
import Address from "@/api/Address";
import AddressService from "@/service/AddressService";
import RenderAddress from "@/components/Shared/RenderAddress.vue";
import AddressesFormView from "@/components/Dashboard/Address/AddressesFormView.vue";
import Loading from "@/components/Shared/Loading.vue";
import RenderEmpty from "@/components/Shared/RenderEmpty.vue";

@Component({
  components: {RenderEmpty, Loading, AddressesFormView, RenderAddress}
})
export default class AddressesListView extends Vue {
  private addresses: Address[] | null = null;
  private addressToEdit: Address | null = null;

  public async getAddresses() {
    this.$store.dispatch('loading/showLoadingModal');
    this.addresses = await AddressService.getAddrsses();
    this.$store.dispatch('loading/hideLoadingModal');
  }

  public async deleteAddress(addressId: number) {
    if (confirm("آیا اطمینان دارید که می‌خواهید این آدرس را حذف کنید؟")) {
      const response = await AddressService.deleteAddrss(addressId);
      if (response.success) {
        this.getAddresses();
      } else {
        alert("آدرس حذف نشد: " + response.message);
      }
    }
  }

  public async setAddressAsDefault(addressId: number) {
    if (confirm("آیا اطمینان دارید که می‌خواهید این آدرس را به عنوان پیش‌فرض انتخاب کنید؟")) {
      const response = await AddressService.setAddressAsDefault(addressId);
      if (response.success) {
        this.getAddresses();
      } else {
        alert("آدرس پیش‌فرض تغییر نکرد: " + response.message);
      }
    }
  }

  public getAddressToEdit() {
    if (this.$route.matched.some(({name}) => name === 'customer-address-new')) {
      this.addressToEdit = new Address();
    } else if (this.$route.matched.some(({name}) => name === 'customer-address-edit')) {
      if (this.addresses) {
        const addressToEditId = parseInt(this.$route.params.addressId);
        for (let i = 0; i < this.addresses.length; i++) {
          const address = this.addresses[i];
          if (address.addressId == addressToEditId) {
            this.addressToEdit = address;
          }
        }
      }
    } else {
      this.addressToEdit = null;
    }
  }

  async mounted() {
    await this.getAddresses();
    this.getAddressToEdit();
  }

  closeAddressForm(status: any) {
    this.$router.push("/customer/address");
    if (status.saved) {
      this.getAddresses();
    }
  }

  @Watch('$route')
  onRouteChanged() {
    this.getAddressToEdit();
  }
}
